import { Badge } from "@mantine/core";
import { useInViewport } from "@mantine/hooks";
import { useEffect } from "react";
import { useStopwatch } from "react-timer-hook";

import { useSession } from "@/hooks/@custom/useSession";
import { QueueCompany, useGetSettingsByCompanyQuery } from "@/store/apis/nextcargo";
import { cn } from "@/utils/cn";
import { getToleranceTime } from "@/utils/getToleranceTime";

export function ToleranceBadge({ queue }: { queue?: QueueCompany }) {
  const { expedition } = useSession();
  const companyId = expedition?.company.id;
  const { data: settings } = useGetSettingsByCompanyQuery({ id: companyId! }, { skip: !companyId });

  const { ref, inViewport } = useInViewport();
  const { start, pause } = useStopwatch();

  const { time, isExhausted } = getToleranceTime({ currentData: queue?.date, toleranceTime: settings?.tolerance });

  useEffect(() => {
    if (inViewport) {
      start();
    }
    if (!inViewport) {
      pause();
    }

    if (isExhausted) {
      pause();
    }
  }, [inViewport]);

  return (
    <Badge color="yellow.6" radius="sm" c="white" classNames={{ label: cn("font-semibold! capitalize!") }} ref={ref}>
      Tolerância • {time}
    </Badge>
  );
}
